// Imports custom
import { Button, Container, Grid, Step, StepLabel, Stepper, Typography } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'
import { PaymentTable } from './PaymentTable'
import { TransactionTable } from './TransactionTable'

const steps = ['Selección de Pago', 'Transacciones']

export const RetroactivePayment = ({ useFetchInit }) => {

    const {
        globalStates,
        Actions
    } = useFetchInit
    const { formOpeningMode, stepApplilication, setStepApplilication } = globalStates

    const { handleClickResetPaymentSelection } = Actions
    
    const isReadOnly = (formOpeningMode==='READONLY')

    const getStepContent = (stepApplilication) => {
        switch (stepApplilication) {
            case 0:
                return <PaymentTable
                    useFetchInit = {useFetchInit}
                    readOnlyMode = {isReadOnly}
                />
            case 1:
                return <TransactionTable
                    useFetchInit = {useFetchInit}
                    readOnlyMode = {isReadOnly}
                />;
            default:
                throw new Error('Unknown step');
        }
    }

    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Informacion sobre la gestion
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
                <Stepper activeStep={stepApplilication} sx={{ pt: 3, pb: 5 }}>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Container>
            {getStepContent(stepApplilication)}
            <div className="pt-4"></div>
            <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>
                <Grid item xs={12}>
                    <div className="text-center">
                        {stepApplilication !== 0 && (
                            <Button
                                variant="contained"
                                type="button"
                                onClick={handleClickResetPaymentSelection} 
                                sx={{ marginRight: 3, marginLeft: 1, background: "#f5f0ed", color: "black" }}
                            >
                                <ArrowLeftCircle/>&nbsp; {isReadOnly ? 'Pagos' : 'Reiniciar'}
                            </Button>
                        )}
                        &nbsp;
                        {( ((stepApplilication) !== (steps.length - 1)) && (isReadOnly) ) && (
                            <Button
                                variant="contained"
                                type="button"
                                onClick={() => {
                                    setStepApplilication(stepApplilication+1)
                                }}
                                style={{ marginRight: 2, marginLeft: 2, background: "#f5f0ed", color: "black" }}
                            >
                                Transacciones&nbsp;<ArrowRightCircle/>
                            </Button>
                        )}
                    </div>
                </Grid>
            </Grid>
            <div className="pt-4"></div>
            <div className="border-bottom border-dark"></div>
            {/* <PaymentTable useFetchInit={useFetchInit}/> */}
        </>
    )
}